import { Toaster, toast } from "sonner";
import { useContext, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Context from "../../Context";
import { LuSend } from "react-icons/lu";
import narattorImg from "../../Images/narattorImg.png";
import Layout from "../../Layout/Layout";
import { Helmet } from "react-helmet-async";
import MobileDetailView from "../../components/MobileDetailView";
import RecommendedPosts from "../../components/RecommendedPosts";

import styled, { createGlobalStyle } from "styled-components";
// import "../../css/Stories.css";
// import "../../css/StoryDetailsNew.css"
import Constant, { statusFailure } from "../../views/Constant";
import {
  DeleteStory,
  getProfileDetails,
  getStories,
  getStoryCategories,
  getStoryDetails,
  getSubcomments,
  getUserportfolioStory,
  getcomments,
  userFollow,
  userLike,
  getDataById,
  deleteComment,
  deleteSubComment,
  sendStoryView,
  getTextToSpeechVoices,
  getTextToSpeechLanguages,
  synthesizeTextToSpeech,
} from "../utilities/ApiCalls";
import {
  existsInPortfolioNew,
  updatePortfolioNew,
} from "../utilities/ApiCalls";
import SindhiFontWoff2 from "../../fonts/SHREE-DEV7-0714.woff2";
import SindhiFontWoff from "../../fonts/SHREE-DEV7-0714.woff";
import {
  FaFacebook,
  FaTwitter,
  FaYoutube,
  FaInstagram,
  FaVolumeUp,
} from "react-icons/fa";
import { getTokenDetails } from "../utilities/CommonFunction";
import { FaRegCommentAlt } from "react-icons/fa";
import {
  CommentCart,
  CommentContainer,
  CommentWritingSection,
  Headerforcomment,
  ReplyInput,
  ScrollableDiv,
} from "./StoryDetailStyle";
import {
  IoChatbubbleOutline,
  IoShareSocialOutline,
  IoHeart,
  IoHeartOutline,
} from "react-icons/io5";
import {
  Clock,
  Clock10Icon,
  Columns,
  Eye,
  EyeIcon,
  GripVertical,
  Link2,
  Plus,
  Scroll,
  Send,
  SendHorizonalIcon,
  SendIcon,
  Settings,
  Settings2,
  Settings2Icon,
  TheaterIcon,
  ThumbsUp,
  Trash,
  UserPlus,
  Play,
  Pause,
  Globe,
  ChevronDown,
  ChevronRight,
  Upload,
} from "lucide-react";
import { RxLayers } from "react-icons/rx";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroll-component";
import Default from "./../../Images/Defaultprofile.png";
import Heart from "../../Images/heart.png";
import ProfileImage from "../../Componets/ProfileImage";
import { useModel } from "../../hooks/modelcontex";

const SindhiFontStyles = createGlobalStyle`
  @font-face {
    font-family: 'SHREE-DEV7-0714';
    src:
      url(${SindhiFontWoff2}) format('woff2'),
      url(${SindhiFontWoff}) format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
`;

function StroyDetailsNew(props) {
  const inputRef = useRef(null);

  let { id } = useParams();

  // Ensure page scrolls to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [id]);
  const [commentLike, setcommentLike] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [story, setStory] = useState({});
  const [viewAll, setViewAll] = useState();
  const [userProfileImage, setUserProfileImage] = useState("");
  const [userProfile, setUserProfile] = useState("");
  const [ReplyOpen, setReplyOpen] = useState();
  const [pageNo, setPageNo] = useState(1);
  const location = useLocation();
  const [commentopen, setcommentopen] = useState(false);
  const [isLike, setLike] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorState, setErrorState] = useState(null);
  const [similarStory, setSimilarStory] = useState([]);
  const history = useHistory();
  const { state, dispatch } = useContext(Context);
  const [similarId, setSimilarId] = useState("");
  const [userId, setUserId] = useState("");
  const [userBadge, setUserBadge] = useState("");
  const [isAccess, setIsAccess] = useState(true);
  const [profile, setProfile] = useState();
  const [Error, setError] = useState();
  const [isFollow, setFollow] = useState(false);
  const [subComment, setsubComment] = useState("");
  const [usercomments, setusercomments] = useState([]);
  const [issubcommentposted, setissubcommentposted] = useState(false);
  const [isposted, setisposted] = useState(false);
  const [userSubcomments, setSubusercomments] = useState({});
  const [replyopen, setreplyopen] = useState("");
  const [comment, setcomment] = useState("");
  const [duration, setDuration] = useState();
  const [isInport, setIsinPort] = useState(false);
  const [badges, setBadges] = useState([]);
  const [category, setcategory] = useState("");
  const [commentlike, setcommentlike] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [openDeleteMenu, setOpenDeleteMenu] = useState(false);
  const { Myprofile, myprofile } = useModel();
  const [activeMenu, setActiveMenu] = useState(null);
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [present, setPresent] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [ttsLanguages, setTtsLanguages] = useState([]);
  const [ttsVoices, setTtsVoices] = useState([]);
  const [selectedTtsLanguage, setSelectedTtsLanguage] = useState("");
  const [selectedTtsVoice, setSelectedTtsVoice] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);
  const [progress, setProgress] = useState(0);
  const [showReplies, setShowReplies] = useState(new Set());
  const [showAllComments, setShowAllComments] = useState(false);
  const [audioCurrentTime, setAudioCurrentTime] = useState(0);
  const [audioDuration, setAudioDuration] = useState(0);

  const getProxiedImageUrl = (url) => {
    if (!url || typeof url !== "string") return Default;
    if (
      url.includes("data:image") ||
      url.includes("blob:") ||
      url.startsWith("static/") ||
      url.startsWith("/static") ||
      url.includes("story-tent-testing.s3.ap-south-1.amazonaws.com")
    )
      return url;
    return `${Constant.apiBasePath}proxy-image?url=${encodeURIComponent(url)}`;
  };

  // Map language names to TTS language codes
  const mapLanguageNameToCode = (languageName) => {
    const languageMap = {
      English: "en-IN",
      Hindi: "hi-IN",
      Marathi: "mr-IN",
      // Add more mappings as needed
    };
    return languageMap[languageName] || null;
  };

  useEffect(() => {
    document.title = story.name;
  }, [story]);

  useEffect(() => {
    inputRef.current?.focus();
    setShowAllComments(false);
  }, [id]);

  // Load TTS languages on component mount
  useEffect(() => {
    const loadTtsLanguages = async () => {
      try {
        const response = await getTextToSpeechLanguages();
        // console.log("TTS Languages Response:", response);
        if (response.status === Constant.statusSuccess) {
          // Filter for specific languages
          const allowedLanguages = ["hi-IN", "en-IN", "mr-IN"];
          const filteredLanguages = response.data.filter((lang) =>
            allowedLanguages.includes(lang.code),
          );
          setTtsLanguages(filteredLanguages);
        }
      } catch (error) {
        console.error("Error loading TTS languages:", error);
      }
    };
    loadTtsLanguages();
  }, []);

  // Load voices when language changes
  useEffect(() => {
    const loadVoices = async () => {
      if (selectedTtsLanguage) {
        try {
          // console.log(
          //   "Fetching voices for language code:",
          //   selectedTtsLanguage
          // );
          const response = await getTextToSpeechVoices(selectedTtsLanguage);
          // console.log("TTS Voices Response:", response);
          if (response.status === Constant.statusSuccess && response.data) {
            // First try to find Standard-D voice
            const standardD = response.data.find((voice) =>
              voice.name.includes("Standard-D"),
            );
            // If not found, try Standard-A as fallback
            const standardA = response.data.find((voice) =>
              voice.name.includes("Standard-A"),
            );
            // Use Standard-D if available, otherwise use Standard-A
            const selectedVoice = standardD || standardA;
            if (selectedVoice) {
              setSelectedTtsVoice(selectedVoice.name);
              // console.log("Selected voice:", selectedVoice.name);
            }
          }
        } catch (error) {
          console.error("Error loading voices:", error);
        }
      }
    };
    loadVoices();
  }, [selectedTtsLanguage]);

  const handleTtsLanguageChange = (e) => {
    const selectedCode = e.target.value;
    // console.log("Selected language code:", selectedCode);
    setSelectedTtsLanguage(selectedCode);
    if (audioRef.current) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  };

  const stripHtmlTags = (html) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const formatTime = (seconds) => {
    if (!seconds || isNaN(seconds)) return "0:00";
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m}:${s.toString().padStart(2, "0")}`;
  };

  const formatTimeAgo = (dateStr) => {
    if (!dateStr) return "";
    const diff = Date.now() - new Date(dateStr).getTime();
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const days = Math.floor(hours / 24);
    if (days > 0) return `${days}D AGO`;
    if (hours > 0) return `${hours}H AGO`;
    const minutes = Math.floor(diff / (1000 * 60));
    if (minutes > 0) return `${minutes}M AGO`;
    return "JUST NOW";
  };

  const formatPostAge = (dateStr) => {
    if (!dateStr) return "";
    const diff = Date.now() - new Date(dateStr).getTime();
    const minutes = Math.floor(diff / (1000 * 60));
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(months / 12);
    if (years > 0) return `${years} year${years > 1 ? "s" : ""} ago`;
    if (months > 0) return `${months} month${months > 1 ? "s" : ""} ago`;
    if (days > 0) return `${days} day${days > 1 ? "s" : ""} ago`;
    if (hours > 0) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    if (minutes > 0) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
    return "just now";
  };

  const formatCount = (count) => {
    if (!count && count !== 0) return 0;
    if (count >= 1000000) return `${(count / 1000000).toFixed(1)}M`;
    if (count >= 1000) return `${(count / 1000).toFixed(1)}K`;
    return count;
  };

  // Detect kind for portfolio based on stripped text (exactly five words => FiveWordStories)
  const detectStoryKind = (html) => {
    const text = stripHtmlTags(html || "").trim();
    const words = text
      .replace(/\s+/g, " ")
      .split(" ")
      .filter((w) => w.length > 0);
    const kind = words.length <= 5 ? "FiveWordStories" : "stories";
    // console.log("[detectStoryKind] strippedText=", text);
    // console.log("[detectStoryKind] wordCount=", words.length, "=> kind=", kind);
    return kind;
  };

  const handleTextToSpeech = async () => {
    if (!story?.description || !selectedTtsVoice || !selectedTtsLanguage) {
      toast.error(
        "Please select both language and voice, and ensure there is text to convert",
      );
      return;
    }

    try {
      // If already playing, stop the audio
      if (isPlaying && audioRef.current) {
        audioRef.current.pause();
        setIsPlaying(false);
        setProgress(0);
        return;
      }

      // Strip HTML tags from the description
      const cleanText = stripHtmlTags(story.description);
      // console.log("Text to synthesize:", cleanText);

      const response = await synthesizeTextToSpeech(
        cleanText,
        selectedTtsVoice,
        selectedTtsLanguage,
      );
      // console.log("TTS Synthesize Response:", response);

      if (response.status === Constant.statusSuccess) {
        // Create audio element and play the synthesized speech
        const audio = new Audio(
          `data:audio/mp3;base64,${response.data.audioContent}`,
        );
        if (audioRef.current) {
          audioRef.current.pause();
        }
        audioRef.current = audio;

        // Set up progress tracking
        audio.addEventListener("timeupdate", () => {
          const progressValue = (audio.currentTime / audio.duration) * 100;
          setProgress(progressValue);
          setAudioCurrentTime(audio.currentTime);
        });

        audio.addEventListener("loadedmetadata", () => {
          setAudioDuration(audio.duration);
        });

        audio.play();
        setIsPlaying(true);

        audio.onended = () => {
          setIsPlaying(false);
          setProgress(0);
          setAudioCurrentTime(0);
        };

        audio.onerror = () => {
          setIsPlaying(false);
          setProgress(0);
          toast.error("Error playing audio");
        };
      }
    } catch (error) {
      console.error("Error synthesizing speech:", error);
      toast.error("Error converting text to speech");
    }
  };

  // Cleanup on component unmount
  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        setIsPlaying(false);
      }
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [portchange, setPortChange] = useState(false);
  const { t } = useTranslation();

  const [copySuccess, setCopySuccess] = useState(false);
  const [sharelink, setShareLink] = useState(false);
  const [link, setlink] = useState("");

  const divRef = useRef(null);

  const isSindhiStory = (story.language || "").toLowerCase() === "sindhi";

  const handleClickOutside = (event) => {
    if (divRef.current && !divRef.current.contains(event.target)) {
      setShareLink(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);
  useEffect(() => {
    const sendviews = async () => {
      const res = await sendStoryView(id);
      if (res && typeof res.totalViews === "number") {
        setStory((prev) => ({
          ...prev,
          totalViews: res.totalViews,
          uniqueViewerCount: res.uniqueViewerCount,
        }));
      }
    };
    sendviews();
  }, [id]);

  async function portfolioStroyfetch() {
    try {
      const token = localStorage.getItem("loginDetails");
      if (!token || !story?._id) return;
      const kind = detectStoryKind(story?.description);
      // console.log(
      //   "[portfolioExists] kind=",
      //   kind,
      //   "userId=",
      //   story.userId,
      //   "itemId=",
      //   story._id
      // );
      const res = await existsInPortfolioNew({
        userId: story.userId,
        itemId: story._id,
        kind,
      });
      if (res.status === Constant.statusSuccess && res.data) {
        setIsinPort(!!res.data.exists);
      } else {
        setIsinPort(false);
      }
    } catch (error) {
      // console.log(error);
      setIsinPort(false);
    }
  }
  useEffect(() => {
    portfolioStroyfetch();
  }, [story, portchange]);

  const copyToClipboard = async (text) => {
    navigator.clipboard.writeText(text);
    // console.log(text);
    setCopySuccess(true);
    setTimeout(() => {
      setCopySuccess(false);
    }, 1000);
  };
  const contentRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function fetchMoreData() {
    // console.log("fetchMoreData");
    let nextPage = pageNo + 1;
    setPageNo(nextPage);
  }

  async function RemoveFromPortfolio(data) {
    try {
      // console.log(data);
      let token = localStorage.getItem("loginDetails");
      let response = await axios.delete(
        Constant.apiBasePath + `portfolio/removeEvent/${data}`,
        { headers: { token: token } },
      );
      // console.log("saved data=======>");
      // console.log(response);
      setPortChange(!portchange);
      return response.data;
    } catch (error) {
      // console.log("internal server error", error);
    }
  }

  async function addtoPortfolio(data) {
    try {
      // console.log(data);
      let token = localStorage.getItem("loginDetails");
      let response = await axios.post(
        Constant.apiBasePath + `portfolio/${data}`,
        { description: " " },
        { headers: { token: token } },
      );
      // console.log("saved data=======>");
      // console.log(response);
      setPortChange(!portchange);
      return response.data;
    } catch (error) {
      // console.log("internal server error", error);
    }
  }

  const SubmitComment = async (e) => {
    e.preventDefault();
    try {
      // console.log("comment", comment);
      let token = localStorage.getItem("loginDetails");

      let response = await axios.post(
        Constant.apiBasePath + `comment/${id}`,
        { description: comment },
        { headers: { token: token } },
      );
      // console.log("comment response", response);
      setcomment("");
      setisposted((curr) => !curr);
      return response.data;
    } catch (error) {
      // console.log("internal server error", error);
    }
  };

  const SubmitSubComment = async (commentId) => {
    try {
      // console.log("subComment", subComment);
      let token = localStorage.getItem("loginDetails");

      let response = await axios.post(
        Constant.apiBasePath + `subComment/${commentId}`,
        { description: subComment },
        { headers: { token: token } },
      );
      // console.log("saved data subcomment=======>");
      // console.log("SubComment response", response);
      setsubComment("");
      setissubcommentposted(!issubcommentposted);
      setReplyOpen("");
      return response.data;
    } catch (error) {
      // console.log("internal server error", error);
    }
  };

  async function CommentLike(data) {
    try {
      let token = localStorage.getItem("loginDetails");
      // console.log(token);
      let response = await axios.patch(
        Constant.apiBasePath + `addRemoveLike/${data}`,
        {},
        { headers: { token: token } },
      );
      // console.log("commentlike-------->");
      setcommentLike(!commentLike);

      return response.data;
    } catch (error) {
      // console.log("internal error", error);
    }
  }

  async function CommentDelete(commentId) {
    try {
      let response = await deleteComment(commentId);
      // console.log("delete comment response", response);
      if (response.status === 200) {
        // console.log("Comment successfully deleted");

        setisposted((curr) => !curr);
      } else {
        console.error("Failed to delete comment:", response.message);
      }
    } catch (error) {
      console.error("Error occurred while deleting comment:", error);
    }
  }
  async function SubCommentDelete(commentId) {
    try {
      let response = await deleteSubComment(commentId);
      // console.log("delete comment response", response);
      if (response.status === 200) {
        // console.log("Comment successfully deleted");

        setisposted((curr) => !curr);
      } else {
        console.error("Failed to delete comment:", response.message);
      }
    } catch (error) {
      console.error("Error occurred while deleting comment:", error);
    }
  }
  const toggleMenu = (commentId) => {
    setActiveMenu((prev) => (prev === commentId ? null : commentId));
  };

  useEffect(() => {
    // console.log(story._id);
    // console.log();
    Usercomments(story._id);
  }, [story, isposted, issubcommentposted, commentLike]);

  async function Usercomments(id) {
    try {
      let usercommentsArray = [];
      const commentsResponse = await getcomments(id);
      const commentsData = commentsResponse.data;

      await Promise.all(
        commentsData.map(async (item) => {
          const subcommentsResponse = await getSubcomments(item._id);
          const subcommentsData = subcommentsResponse.data;

          usercommentsArray.push({
            usercomment: item,
            usersubcomments: subcommentsData,
          });
        }),
      );
      usercommentsArray.sort((a, b) => {
        return (
          new Date(a.usercomment.createdAt) - new Date(b.usercomment.createdAt)
        );
      });
      // console.log("usercommentsArray", usercommentsArray);
      setusercomments(usercommentsArray);
    } catch (error) {
      console.error("Error fetching comments and subcomments:", error);
    }
  }

  const Category = () => {
    getStoryCategories().then((response) => {
      // console.log(response);
      response.data.map((data) => {
        if (data._id == story.categoryId) {
          setcategory(data.name);
        }
      });
    });
  };

  useEffect(() => {
    Category();
  }, [story]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (contentRef.current && !contentRef.current.contains(event.target)) {
        setcommentopen(false);
        // console.log("Clicked outside. Closing...");
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    getProfileDetails().then((response) => {
      if (response.status !== statusFailure) {
        setProfile(response.data.data);
      } else {
        setError(response.message);
      }
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // console.log(id);
        let prams = { id: id };
        let token = localStorage.getItem("loginDetails");

        if (similarId) {
          prams = { id: similarId };
        } else {
          // console.log("similar id not found");
        }

        if (token) {
          let userDetails = getTokenDetails(token);
          if (userDetails) {
            prams.user_id = userDetails._id;
            setUserId(userDetails._id);
          }
        } else {
          // console.log("user not found");
        }

        if (state.user.userBadge) {
          setUserBadge(state.user.userBadge.title);
        }

        const response = await getStoryDetails(prams);
        console.log("📚 [StoryDetailsNew] Full API Response:", response);
        console.log("📚 [StoryDetailsNew] Story Data:", response.data?.[0]);
        console.log(
          "📚 [StoryDetailsNew] Story Language Field:",
          response.data?.[0]?.language,
        );
        if (response.status !== statusFailure) {
          setStory((prev) => {
            const next = response.data[0];
            const totalViews = Math.max(
              prev?.totalViews ?? 0,
              next?.totalViews ?? 0,
            );
            const uniqueViewerCount = Math.max(
              prev?.uniqueViewerCount ?? 0,
              next?.uniqueViewerCount ?? 0,
            );
            return { ...next, totalViews, uniqueViewerCount };
          });
          setSimilarStory(response.similarStory);
          setIsAccess(response.isAccess);
          // Initialize follow status from API response
          setFollow(response.data[0].userFollow || false);

          // Set default language from story data
          if (response.data[0]?.language) {
            const languageCode = mapLanguageNameToCode(
              response.data[0].language,
            );
            if (languageCode) {
              setSelectedTtsLanguage(languageCode);
            }
          }

          if (response.isAccess === false || response.isBadge === true) {
            setSuccessMessage(response.message);
          }
        } else {
          setErrorState(response.message);
          setTimeout(() => {
            setErrorState("");
          }, 3000);
        }
      } catch (error) {
        console.error("Error fetching story details:", error);
        history.push("/");
        setErrorState("An error occurred while fetching the story details.");
        setTimeout(() => {
          setErrorState("");
        }, 3000);
      }
    };

    fetchData();
  }, [isLike, similarId, isFollow, id]);

  const Duration = (createdAt) => {
    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    const currentDate = Date.now();
    const differenceInMilliseconds =
      currentDate - new Date(createdAt).getTime();
    const days = Math.floor(differenceInMilliseconds / millisecondsPerDay);
    return days;
  };

  function like() {
    let token = localStorage.getItem("loginDetails");
    let { _id } = getTokenDetails(token);
    let likeRequest = {
      moduleId: story._id,
      type: 1,
      user_id: _id,
      title: story.name,
      description: story.description,
      thumbnail: story.thumbnail,
    };

    userLike(likeRequest).then((response) => {
      if (response.status !== statusFailure) {
        setLike(response.data.userLike);
      }
    });
  }

  function extractDate(createdAt) {
    const date = new Date(createdAt);

    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    return `${year}-${month < 10 ? "0" + month : month}-${
      day < 10 ? "0" + day : day
    }`;
  }

  function verifyUser(id, standard) {
    setSimilarId(id);
    if (standard === 2) {
      if (state.user.isPrime) {
        history.push("/story-details/" + id);
      } else {
        history.push("/story-details/" + id);
      }
    } else {
      history.push("/story-details/" + id);
    }
  }

  function follow(followingId, status) {
    // console.log("fdkj");
    let userStatus = status ? 0 : 1;
    let userRequest = {
      followingId: followingId,
      status: userStatus,
    };

    // console.log(userRequest);

    userFollow(userRequest).then((response) => {
      // console.log(response);
      if (response.status !== statusFailure) {
        setFollow(!isFollow);
      }
    });
  }

  const Delete = () => {
    let param = {};
    param.userId = story.userId;
    param.id = story._id;

    DeleteStory(param).then((response) => {
      // console.log(response);
    });

    history.push("/");
  };

  // console.log(usercomments);

  const closePopup = () => setIsPopupOpen(false);
  const openPopup = () => setIsPopupOpen(true);

  useEffect(() => {
    const check = async () => {
      try {
        const kind = detectStoryKind(story?.description);
        // console.log(
        //   "[initialPresentCheck] kind=",
        //   kind,
        //   "userId=",
        //   story.userId,
        //   "itemId=",
        //   id
        // );
        const res = await existsInPortfolioNew({
          userId: story.userId,
          itemId: id,
          kind,
        });
        if (res.status === Constant.statusSuccess && res.data) {
          setPresent(!!res.data.exists);
        } else {
          setPresent(false);
        }
      } catch (err) {
        // console.log(err);
        setPresent(false);
      }
    };

    if (story && story.userId) {
      check();
    }
  }, [story, id]);

  const handleAddToPortfolio = async () => {
    let token = localStorage.getItem("loginDetails");

    try {
      const kind = detectStoryKind(story?.description);
      // console.log("[portfolioAdd] kind=", kind, "payloadId=", id);
      const payload = { userId: story.userId, action: "add", [kind]: [id] };
      const res = await updatePortfolioNew(payload);
      if (res.status === Constant.statusSuccess) {
        toast.success("added successfully in portfolio");
        closePopup();
        setPresent(true);
      } else {
        toast.error(res.message || "Failed to add to portfolio");
        closePopup();
      }
    } catch (error) {
      toast.error("Error adding to portfolio");
      console.error("Error updating portfolio", error);
      closePopup();
    }
  };
  const handleDeleteFromPortfolio = async () => {
    let token = localStorage.getItem("loginDetails");

    try {
      const kind = detectStoryKind(story?.description);
      // console.log("[portfolioRemove] kind=", kind, "payloadId=", id);
      const payload = { userId: story.userId, action: "remove", [kind]: [id] };
      const res = await updatePortfolioNew(payload);
      if (res.status === Constant.statusSuccess) {
        toast.success("Removed successfully from portfolio");
        closePopup();
        setPresent(false);
      } else {
        toast.error(res.message || "Failed to remove from portfolio");
        closePopup();
      }
    } catch (error) {
      toast.error("Error while updating portfolio");
      console.error("Error updating portfolio", error);
      closePopup();
    }
  };
  const handleMessageClick = () => {
    inputRef.current?.focus();
  };

  return (
    <>
      <Toaster />
      <Helmet>
        <title>{story.name}</title>
        <meta name="description" content={story.userName} />
        <meta property="og:title" content={story.name} />
        <meta property="og:description" content={story.userName} />
        <meta property="og:image" content={story.thumbnail} />
        <meta property="og:url" content={window.location.href} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={story.name} />
        <meta name="twitter:description" content={story.userName} />
        <meta name="twitter:image" content={story.thumbnail} />
      </Helmet>
      <Layout>
        <div
          style={{
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            backgroundColor: "transparent",
            height: "auto",
          }}
        >
          <Root bgImg={story.thumbnail}>
            <SindhiFontStyles />
            {size.width > 700 ? (
              <div className="story-container">
                <div className="story-header">
                  <div className="story-heading">
                    <div className="user-profile">
                      <Link
                        to={
                          story.userId === myprofile._id
                            ? `/profile`
                            : `/userprofile/${story.userId}`
                        }
                      >
                        <div className="user-details">
                          <ProfileImage
                            src={story?.profilePic}
                            name={story?.userName || story?.name}
                            size={50}
                            className="user-img"
                            alt="userprofile"
                            proxiedUrl={getProxiedImageUrl}
                          />
                          <div className="user-name">
                            <div className="name">{story.userName}</div>
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div
                      className="heading"
                      style={
                        isSindhiStory
                          ? {
                              fontFamily: "SHREE-DEV7-0714",
                              fontSize: "26px",
                            }
                          : undefined
                      }
                    >
                      {story.name}
                    </div>
                    <div className="metadata-tags metadata-tags-desktop">
                      {story.categoryName && story.categoryName !== "" && (
                        <div className="badge-tag">
                          <RxLayers size={11} />
                          {story.categoryName.toUpperCase()}
                        </div>
                      )}
                      <div className="badge-tag">
                        <Clock size={11} />
                        {story.duration}MIN
                      </div>
                      <div className="badge-tag badge-lang-container">
                        <Globe size={11} />
                        <span>
                          {(
                            ttsLanguages.find(
                              (l) => l.code === selectedTtsLanguage,
                            )?.name ||
                            story.language ||
                            "Language"
                          ).toUpperCase()}
                        </span>
                        <ChevronDown size={11} />
                        <select
                          className="lang-select-overlay"
                          value={selectedTtsLanguage}
                          onChange={handleTtsLanguageChange}
                          title="Select language"
                          aria-label="Select language"
                        >
                          <option value="">Select Language</option>
                          {ttsLanguages.map((lang) => (
                            <option key={lang.code} value={lang.code}>
                              {lang.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      {story.userId === myprofile._id && (
                        <div className="owner-actions">
                          {present ? (
                            <button
                              className="portfolio-btn"
                              onClick={handleDeleteFromPortfolio}
                              title="Remove from portfolio"
                              aria-label="Remove from portfolio"
                            >
                              -
                            </button>
                          ) : (
                            <button
                              className="portfolio-btn"
                              onClick={handleAddToPortfolio}
                              title="Add to portfolio"
                              aria-label="Add to portfolio"
                            >
                              +
                            </button>
                          )}
                          <i
                            style={{
                              color: "var(--color-text-tertiary)",
                              cursor: "pointer",
                            }}
                            className="fa fa-ellipsis-h"
                            onClick={() => setOpenDelete(true)}
                            title="More options"
                            aria-label="More options"
                          ></i>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="thumbnail">
                    <img
                      src={story.thumbnail}
                      alt="thumbnail"
                      className="img"
                    ></img>
                  </div>
                </div>
                <div className="metadata-tags metadata-tags-mobile">
                  {story.categoryName && story.categoryName !== "" && (
                    <div className="badge-tag">
                      <RxLayers size={11} />
                      {story.categoryName.toUpperCase()}
                    </div>
                  )}
                  <div className="badge-tag">
                    <Clock size={11} />
                    {story.duration}MIN
                  </div>
                  <div className="badge-tag badge-lang-container">
                    <Globe size={11} />
                    <span>
                      {(
                        ttsLanguages.find(
                          (l) => l.code === selectedTtsLanguage,
                        )?.name ||
                        story.language ||
                        "Language"
                      ).toUpperCase()}
                    </span>
                    <ChevronDown size={11} />
                    <select
                      className="lang-select-overlay"
                      value={selectedTtsLanguage}
                      onChange={handleTtsLanguageChange}
                      title="Select language"
                      aria-label="Select language"
                    >
                      <option value="">Select Language</option>
                      {ttsLanguages.map((lang) => (
                        <option key={lang.code} value={lang.code}>
                          {lang.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  {story.userId === myprofile._id && (
                    <div className="owner-actions-mobile">
                      {present ? (
                        <button
                          className="portfolio-btn"
                          onClick={handleDeleteFromPortfolio}
                          title="Remove from portfolio"
                          aria-label="Remove from portfolio"
                        >
                          -
                        </button>
                      ) : (
                        <button
                          className="portfolio-btn"
                          onClick={handleAddToPortfolio}
                          title="Add to portfolio"
                          aria-label="Add to portfolio"
                        >
                          +
                        </button>
                      )}
                      <i
                        style={{
                          color: "var(--color-text-tertiary)",
                          cursor: "pointer",
                        }}
                        className="fa fa-ellipsis-h"
                        onClick={() => setOpenDelete(true)}
                        title="More options"
                        aria-label="More options"
                      ></i>
                    </div>
                  )}
                </div>
                <div className="audio-player-card">
                  <button
                    className={`audio-play-btn${isPlaying ? " playing" : ""}`}
                    onClick={handleTextToSpeech}
                    title={isPlaying ? "Pause narration" : "Play narration"}
                    aria-label={isPlaying ? "Pause narration" : "Play narration"}
                  >
                    {isPlaying ? <Pause size={16} /> : <Play size={16} />}
                  </button>
                  <div className="audio-player-info">
                    <div className="audio-player-header">
                      <span className="audio-label">AUDIO STORY</span>
                      <span className="audio-time">
                        {formatTime(audioCurrentTime)} /{" "}
                        {formatTime(audioDuration)}
                      </span>
                    </div>
                    <div className="audio-progress-bar">
                      <div
                        className="audio-progress-fill"
                        style={{ width: `${progress}%` }}
                      ></div>
                    </div>
                  </div>
                </div>
                <div
                  style={{ color: "var(--color-text-tertiary) !important" }}
                  className={`story-description${
                    isSindhiStory ? " sindhi-text" : ""
                  }`}
                  dangerouslySetInnerHTML={{ __html: story.description }}
                ></div>
                <div className="story-options">
                  <div className="engagement-left">
                    <span className="engagement-stat">
                      {story.userLike ? (
                        <IoHeart
                          onClick={() => like()}
                          style={{ fontSize: "18px", color: "#FF0000", cursor: "pointer" }}
                          title="Unlike story"
                          aria-label="Unlike story"
                        />
                      ) : (
                        <IoHeartOutline
                          style={{ cursor: "pointer", fontSize: "18px", strokeWidth: "1.5" }}
                          onClick={like}
                          title="Like story"
                          aria-label="Like story"
                        />
                      )}
                      {formatCount(story.likes)}
                    </span>
                    <span className="engagement-stat">
                      <IoChatbubbleOutline
                        style={{ fontSize: "18px", strokeWidth: "1.5" }}
                        title="Comments"
                        aria-label="Comments"
                      />
                      {formatCount(usercomments.length)}
                    </span>
                    <span className="engagement-stat" title="Views" aria-label="Views">
                      <Eye style={{ width: "18px", height: "18px", flexShrink: 0 }} />
                      {formatCount(story.totalViews ?? story.viewCount ?? 0)}
                    </span>
                  </div>
                  <button
                    className="share-action-btn"
                    onClick={() => {
                      setShareLink(true);
                      setlink(`https://www.storytent.in/story-details/${story._id}`);
                    }}
                    title="Share story"
                    aria-label="Share story"
                  >
                    <Upload size={15} />
                    SHARE
                  </button>
                </div>

                <div className="comment-section">
                  <form className="form">
                    <div className="comment-input-wrapper">
                      <ProfileImage
                        src={profile?.profilePic}
                        name={profile?.userName || profile?.name || "ME"}
                        size={32}
                        className="comment-avatar"
                        alt="profile"
                        proxiedUrl={getProxiedImageUrl}
                        avatarProps={{
                          className: "comment-avatar-placeholder",
                          backgroundColor: "var(--color-primary)",
                          color: "var(--color-surface)",
                        }}
                      />
                      <input
                        ref={inputRef}
                        value={comment}
                        onChange={(e) => setcomment(e.target.value)}
                        placeholder="Share your thoughts..."
                        className="comment-input"
                      ></input>
                      <button
                        type="button"
                        onClick={(e) => SubmitComment(e)}
                        className="respond-btn"
                        title="Post comment"
                        aria-label="Post comment"
                      >
                        <ChevronRight size={18} />
                      </button>
                    </div>
                  </form>
                  {usercomments.length > 0 ? (
                    <div className="comments">
                      {(showAllComments
                        ? usercomments
                        : usercomments.slice(0, 2)
                      ).map((data) => {
                          return (
                            <div className="comment-cart" key={data.usercomment._id}>
                              {/* Avatar + Bubble */}
                              <div className="comment-bubble-row">
                                <ProfileImage
                                  src={data.usercomment?.userProfilePicture}
                                  name={
                                    data.usercomment?.userName ||
                                    data.usercomment?.name
                                  }
                                  size={35}
                                  className="profile-img"
                                  alt="profile"
                                  proxiedUrl={getProxiedImageUrl}
                                />
                                <div className="comment-bubble">
                                  <div className="comment-bubble-header">
                                    <span className="comment-bubble-author">
                                      {data.usercomment.userName}
                                    </span>
                                    {data.usercomment.userId === myprofile._id && (
                                      <span
                                        className="delete-comment-btn"
                                        onClick={() =>
                                          CommentDelete(data.usercomment._id)
                                        }
                                        title="Delete comment"
                                        aria-label="Delete comment"
                                      >
                                        <Trash size={14} />
                                      </span>
                                    )}
                                  </div>
                                  <div className="comment-bubble-text">
                                    {data.usercomment.description ||
                                      data.usercomment.comment}
                                  </div>
                                </div>
                              </div>
                              {/* Actions below bubble */}
                              <div className="comment-meta">
                                <span
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "1px",
                                    marginRight: "8px",
                                  }}
                                >
                                  <span
                                    className="likeicon"
                                    onClick={() =>
                                      CommentLike(data.usercomment._id)
                                    }
                                    title={
                                      data.usercomment.likes.some(
                                        (like) => like.userId === myprofile._id,
                                      )
                                        ? "Unlike comment"
                                        : "Like comment"
                                    }
                                    aria-label={
                                      data.usercomment.likes.some(
                                        (like) => like.userId === myprofile._id,
                                      )
                                        ? "Unlike comment"
                                        : "Like comment"
                                    }
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {data.usercomment.likes.some(
                                      (like) => like.userId === myprofile._id,
                                    ) ? (
                                      <IoHeart
                                        style={{
                                          cursor: "pointer",
                                          color: "red",
                                          fontSize: "14px",
                                        }}
                                      />
                                    ) : (
                                      <IoHeartOutline
                                        style={{
                                          cursor: "pointer",
                                          color: "var(--color-text-secondary)",
                                          fontSize: "14px",
                                        }}
                                      />
                                    )}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      color: "var(--color-text-secondary)",
                                    }}
                                  >
                                    {data.usercomment.likes.length}
                                  </span>
                                </span>
                                <span
                                  className="reply-link"
                                  onClick={() => {
                                    if (ReplyOpen === data.usercomment._id) {
                                      setReplyOpen("");
                                    } else {
                                      setReplyOpen(data.usercomment._id);
                                    }
                                  }}
                                  style={{ marginRight: "8px" }}
                                >
                                  REPLY
                                </span>
                              </div>
                              {/* Reply input */}
                              {ReplyOpen === data.usercomment._id && (
                                <div className="reply-section">
                                  <form className="subform">
                                    <div className="subcomment-input-wrapper">
                                      <ProfileImage
                                        src={profile?.profilePic}
                                        name={
                                          profile?.userName ||
                                          profile?.name ||
                                          "ME"
                                        }
                                        size={32}
                                        className="comment-avatar-small"
                                        alt="profile"
                                        proxiedUrl={getProxiedImageUrl}
                                        avatarProps={{
                                          className:
                                            "comment-avatar-placeholder-small",
                                          backgroundColor:
                                            "var(--color-primary)",
                                          color: "var(--color-surface)",
                                        }}
                                      />
                                      <input
                                        className="subcomment-input"
                                        value={subComment}
                                        onChange={(e) =>
                                          setsubComment(e.target.value)
                                        }
                                        placeholder="Add a reply..."
                                      ></input>
                                      <button
                                        type="button"
                                        className="subsend-btn"
                                        onClick={() =>
                                          SubmitSubComment(data.usercomment._id)
                                        }
                                        title="Post reply"
                                        aria-label="Post reply"
                                      >
                                        <SendIcon />
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              )}
                              {/* Nested replies with toggle inside */}
                              {data.usersubcomments &&
                                data.usersubcomments.length > 0 && (
                                  <div className="subcomments">
                                    <span
                                      className="show-replies-link"
                                      onClick={() => {
                                        const newShowReplies = new Set(
                                          showReplies,
                                        );
                                        if (
                                          newShowReplies.has(
                                            data.usercomment._id,
                                          )
                                        ) {
                                          newShowReplies.delete(
                                            data.usercomment._id,
                                          );
                                        } else {
                                          newShowReplies.add(
                                            data.usercomment._id,
                                          );
                                        }
                                        setShowReplies(newShowReplies);
                                      }}
                                    >
                                      {showReplies.has(data.usercomment._id)
                                        ? "Hide Replies"
                                        : `Show Replies (${data.usersubcomments.length})`}
                                    </span>
                                    {showReplies.has(data.usercomment._id) &&
                                      data.usersubcomments.map((subcomment) => {
                                      return (
                                        <div className="subcomment-cart" key={subcomment._id}>
                                          <div className="comment-bubble-row">
                                            <ProfileImage
                                              src={
                                                subcomment?.userProfilePicture
                                              }
                                              name={
                                                subcomment?.userName ||
                                                subcomment?.name
                                              }
                                              size={30}
                                              className="profile-img"
                                              alt="profile"
                                              proxiedUrl={getProxiedImageUrl}
                                            />
                                            <div className="comment-bubble">
                                              <div className="comment-bubble-header">
                                                <span className="comment-bubble-author">
                                                  {subcomment.userName}
                                                </span>
                                                {subcomment.userId ===
                                                  myprofile._id && (
                                                  <span
                                                    className="delete-comment-btn"
                                                    onClick={() =>
                                                      SubCommentDelete(
                                                        subcomment._id,
                                                      )
                                                    }
                                                    title="Delete reply"
                                                    aria-label="Delete reply"
                                                  >
                                                    <Trash size={14} />
                                                  </span>
                                                )}
                                              </div>
                                              <div className="comment-bubble-text">
                                                {subcomment.description ||
                                                  subcomment.comment}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="comment-meta">
                                            <span
                                              style={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: "1px",
                                                marginRight: "8px",
                                              }}
                                            >
                                              <span
                                                className="likeicon"
                                                onClick={() =>
                                                  CommentLike(subcomment._id)
                                                }
                                                title={
                                                  subcomment.likes?.some(
                                                    (like) =>
                                                      like.userId ===
                                                      myprofile._id,
                                                  )
                                                    ? "Unlike comment"
                                                    : "Like comment"
                                                }
                                                aria-label={
                                                  subcomment.likes?.some(
                                                    (like) =>
                                                      like.userId ===
                                                      myprofile._id,
                                                  )
                                                    ? "Unlike comment"
                                                    : "Like comment"
                                                }
                                                style={{
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                {subcomment.likes?.some(
                                                  (like) =>
                                                    like.userId ===
                                                    myprofile._id,
                                                ) ? (
                                                  <IoHeart
                                                    style={{
                                                      cursor: "pointer",
                                                      color: "red",
                                                      fontSize: "14px",
                                                    }}
                                                  />
                                                ) : (
                                                  <IoHeartOutline
                                                    style={{
                                                      cursor: "pointer",
                                                      color:
                                                        "var(--color-text-secondary)",
                                                      fontSize: "14px",
                                                    }}
                                                  />
                                                )}
                                              </span>
                                              <span
                                                style={{
                                                  fontSize: "12px",
                                                  color:
                                                    "var(--color-text-secondary)",
                                                }}
                                              >
                                                {subcomment.likes?.length || 0}
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                            </div>
                          );
                        })}
                      {usercomments.length > 2 && !showAllComments && (
                        <button
                          className="view-all-btn"
                          onClick={() => setShowAllComments(true)}
                        >
                          VIEW ALL {usercomments.length} COMMENTS
                        </button>
                      )}
                    </div>
                  ) : null}
                </div>
                <RecommendedPosts id={id} sourceType="story" />
              </div>
            ) : (
              <>
                <MobileDetailView
                  content={story}
                  type="story"
                  category={story.categoryName || category}
                  description={story.description}
                  profile={profile}
                  myprofile={myprofile}
                  isFollow={isFollow}
                  onLike={like}
                  onFollow={follow}
                  onShare={() => {
                    setShareLink(true);
                    setlink(
                      `https://www.storytent.in/story-details/${story._id}`,
                    );
                  }}
                  onOpenMenu={() => setOpenDelete(true)}
                  onSubmitComment={SubmitComment}
                  onCommentLike={CommentLike}
                  onReply={SubmitSubComment}
                  onDeleteComment={CommentDelete}
                  onDeleteSubComment={SubCommentDelete}
                  usercomments={usercomments}
                  comment={comment}
                  setComment={setcomment}
                  subComment={subComment}
                  setSubComment={setsubComment}
                  ReplyOpen={ReplyOpen}
                  setReplyOpen={setReplyOpen}
                  openComment={replyopen}
                  setOpenComment={setreplyopen}
                  ttsLanguages={ttsLanguages}
                  selectedTtsLanguage={selectedTtsLanguage}
                  onTtsLanguageChange={handleTtsLanguageChange}
                  onTextToSpeech={handleTextToSpeech}
                  isPlaying={isPlaying}
                  progress={progress}
                  audioCurrentTime={audioCurrentTime}
                  audioDuration={audioDuration}
                  present={present}
                  onAddToPortfolio={handleAddToPortfolio}
                  onDeleteFromPortfolio={handleDeleteFromPortfolio}
                  inputRef={inputRef}
                  recommendedSection={
                    <RecommendedPosts id={id} sourceType="story" />
                  }
                  t={t}
                />
              </>
            )}

            {sharelink && (
              <div ref={divRef} className="share-box">
                <div
                  onClick={() => setShareLink(false)}
                  style={{
                    position: "absolute",
                    right: "0px",
                    cursor: "pointer",
                  }}
                  title="Close"
                  aria-label="Close"
                >
                  <Plus
                    style={{
                      transform: "rotate(45deg)",
                      color: "white",
                      cursor: "pointer",
                    }}
                  ></Plus>
                </div>
                <div
                  style={{
                    textAlign: "center",
                    color: "white",
                    fontSize: "20px",
                  }}
                >
                  Share
                </div>
                <div className="share-link-icon">
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      copyToClipboard(link);
                      setShareLink(false);
                    }}
                    className="icon-container"
                    title="Copy link"
                    aria-label="Copy link"
                  >
                    <Link2></Link2>
                  </span>
                </div>
                <div
                  style={{
                    textAlign: "center",
                    color: "var(--color-text-tertiary)",
                  }}
                >
                  Copy Link
                </div>
              </div>
            )}

            {openDelete && (
              <div className="Delete-Pop-up">
                <div
                  onClick={() => setOpenDelete(false)}
                  style={{
                    position: "absolute",
                    top: "2px",
                    right: "2px",
                    transform: "rotate(45deg)",
                    padding: "2px",
                    color: "#666",
                    cursor: "pointer",
                  }}
                  title="Close"
                  aria-label="Close"
                >
                  <Plus></Plus>
                </div>
                <div
                  className="delete"
                  onClick={() => Delete()}
                  style={{
                    display: "flex",
                    gap: "20px",
                    cursor: "pointer",
                    color: "var(--color-error)",
                  }}
                  title="Delete story"
                  aria-label="Delete story"
                >
                  <Trash></Trash>{" "}
                  <span style={{ color: "#333", fontWeight: "600" }}>
                    Delete
                  </span>
                </div>
              </div>
            )}
          </Root>
        </div>
      </Layout>
    </>
  );
}

export default StroyDetailsNew;

const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: "#444141",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    width: "300px",
    position: "relative",
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    background: "none",
    border: "none",
    fontSize: "18px",
    cursor: "pointer",
  },
  addButton: {
    padding: "10px 20px",
    backgroundColor: "gray",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "16px",
  },
};

const Root = styled.div`
  min-height: 100vh;
  height: auto;
  background-color: transparent;
  margin-top: -16px;
  display: flex;
  width: 100%;
  overflow: hidden;
  max-width: 1300px;
  position: relative;
  flex-direction: column;
  align-items: center;

  .Delete-Pop-up {
    width: 200px;
    height: 100px;
    background-color: var(--color-surface);
    border: 1px solid var(--color-border);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    border-radius: 20px;
    position: fixed;
    top: 50%;
    left: 50%;
    align-items: center;
    justify-content: center;
    display: flex;
    transform: translate(-50%, -50%);
    z-index: 10000;
  }

  .sub-comment-box {
    display: flex;
    justify-content: space-between;
    width: 98%;
    color: var(--color-text-tertiary);

    @media screen and (min-width: 350px) and (max-width: 1100px) {
      padding-right: 10px;
    }
  }

  .share-link-icon {
    margin-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .delete:hover {
    background-color: gray;
    padding: 2px;
    width: 150px;
    border-radius: 10px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .share-box {
    width: 300px;
    height: 130px;
    border-radius: 10px;
    background-color: #023020;
    position: fixed;
    top: 400px;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .icon-container {
    background-color: var(--color-surface);
    padding: 10px;
    padding-left: 12px;
    padding-right: 12px;
    border-radius: 100px;
  }

  .gener {
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 3px;
    padding-bottom: 3px;
    border-radius: 15px;
    color: #ffffff;
    font-weight: 500;
    backdrop-filter: blur(4px);
  }

  .eye {
    color: #ffffff;
    font-size: 12px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  }

  .likeicon {
    color: var(--color-text-tertiary);
    width: 20px;
    height: 20px;
  }

  .user-name {
    display: flex;
    flex-direction: column;
    gap: 2px;
    text-decoration: none;
  }

  .user-name .name {
    color: var(--color-text);
  }

  .user-name .time {
    color: var(--color-text-secondary);
  }

  .user-profile a {
    text-decoration: none;
  }

  .like {
    width: 25px;
    height: 25px;
  }

  .view {
    margin-left: 75px;
    margin-top: 10px;
  }

  .comment-icons {
    display: flex;
    margin-left: 60px;
    font-size: 12px;
    gap: 12px;
    color: var(--color-text-tertiary);
  }

  .comment-time {
    color: var(--color-text-tertiary);
  }

  .comment-likes {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .like-count {
    color: var(--color-text-tertiary);
  }

  .comment-bubble-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 8px;
  }

  .comment-bubble {
    flex: 1;
    background-color: #f1f3f5;
    border-radius: 12px;
    padding: 10px 14px;
  }

  .comment-bubble-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
  }

  .comment-bubble-author {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: var(--color-text-tertiary);
  }

  .comment-bubble-text {
    font-size: 14px;
    color: var(--color-text-tertiary);
    line-height: 1.45;
  }

  .comment-meta {
    margin-left: 45px;
    margin-top: 6px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .reply-link {
    color: var(--color-text-secondary);
    cursor: pointer;
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  .reply-link:hover {
    color: var(--color-primary);
  }
  .hr {
    border: 1px solid;
    opacity: 0.5;
  }

  .comment-text {
    display: none;
  }

  .profile-name {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    color: var(--color-text-tertiary);
    margin-top: 0px;
    line-height: 1.2;
  }

  .profile-name span {
    margin: 0;
    line-height: 1.2;
  }

  .sound-setting {
    display: flex;
    align-items: end;
    justify-content: end;
    gap: 20px;
    margin-top: 20px;
    @media (min-width: 350px) and (max-width: 700px) {
      margin-right: 20px;
    }
  }

  .select {
    width: 80px;
    background-color: var(--color-surface);
    opacity: 0.5;
    padding-left: 5px;
    padding-right: 5px;
    outline: none;
    border: none;
    color: var(--color-text-tertiary);
    border-radius: 20px;
    text-align: center;
  }

  .story-options {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid var(--color-border);
    color: var(--color-text-secondary);
    margin-bottom: 10px;

    @media (max-width: 480px) {
      padding-top: 12px;
      margin-top: 12px;
    }
  }

  .engagement-left {
    display: flex;
    align-items: center;
    gap: 20px;

    @media (max-width: 480px) {
      gap: 14px;
    }
  }

  .engagement-stat {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 15px;
    font-weight: 500;
    color: var(--color-text-secondary);

    svg {
      color: var(--color-text-secondary);
    }
  }

  .share-action-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: transparent;
    border: none;
    cursor: pointer;
    color: var(--color-text-secondary);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding: 4px 0;
    transition: color 0.2s;
    flex-shrink: 0;

    svg {
      color: var(--color-text-secondary);
      transition: color 0.2s;
    }

    &:hover {
      color: var(--color-primary);
      svg {
        color: var(--color-primary);
      }
    }

    @media (max-width: 480px) {
      font-size: 11px;
      gap: 4px;
    }
  }

  .desc {
    color: var(--color-text-tertiary);
    margin-top: 20px;
    margin-left: 20px;
    font-weight: bold;
  }

  .text {
    margin-top: 20px;
    margin-left: 20px;
    color: var(--color-text-tertiary);
  }

  .user-profile-mobile {
    display: flex;
    padding-left: 20px;
    display: flex;
    justify-content: space-between;
    padding-right: 20px;
  }

  .drop {
    position: absolute;
    width: 390px;
    height: 100px;
    background-color: var(--color-surface);
    z-index: 100;
  }

  .heading-mobile {
    display: flex;
    color: #ffffff;
    font-size: 18px;
    margin-bottom: 10px;
    margin-left: 24px;
    line-height: 1.2;
    letter-spacing: -0.3px;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);

    @media (min-width: 350px) and (max-width: 450px) {
      font-size: 18px;
    }
  }

  .inner-box-mobile {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 80%;
    max-width: 400px;
    min-height: 120px;
    padding-bottom: 20px;
    height: auto;
    @media (min-width: 350px) and (max-width: 600px) {
      width: 85%;
      max-width: 350px;
      min-height: 120px;
    }
  }

  .story-container-mobile {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
    background-color: var(--color-surface);
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
  }

  .img-cover {
    width: 100%;
    height: 100%;
  }

  .story-description-mobile {
    display: flex;
    flex-direction: column;
    padding-left: 25px;
    padding-right: 25px;
    padding-top: 20px;
    text-align: justify;
    min-height: 250px;
    height: auto;
    color: var(--color-text-tertiary);
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    line-height: 1.8;
    word-wrap: break-word;
    white-space: normal;
  }

  .story-description-mobile p,
  .story-description-mobile span,
  .story-description-mobile strong,
  .story-description-mobile em,
  .story-description-mobile u,
  .story-description-mobile * {
    color: var(--color-text-tertiary) !important;
  }

  .Stroy-header-mobile {
    position: relative;
    width: 100%;
    height: 250px;
    background: transparent;
    background-image: ${(props) => `url(${props.bgImg})`};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-item: end;
    justify-content: end;
  }

  .Stroy-header-mobile::before {
    content: "";
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .comment-input-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    background-color: var(--color-background);
    border: 1px solid var(--color-border);
    border-radius: 40px;
    padding: 8px 8px 8px 14px;
  }

  .comment-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
  }

  .comment-avatar-placeholder {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: var(--color-primary);
    color: var(--color-surface);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 14px;
    flex-shrink: 0;
  }

  .comment-input {
    flex: 1;
    border: none;
    outline: none;
    background-color: transparent;
    color: var(--color-text-tertiary);
    font-size: 14px;
    padding: 0;
  }

  .comment-input::placeholder {
    color: var(--color-text-secondary);
  }

  .respond-btn {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: var(--color-text);
    color: var(--color-surface);
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: opacity 0.2s;
  }

  .respond-btn:hover {
    opacity: 0.8;
  }

  .respond-btn svg {
    color: var(--color-surface);
  }

  .responses-heading {
    color: var(--color-text-tertiary);
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .reply-section {
    margin-top: 15px;
    margin-left: 50px;
    padding-top: 15px;
  }

  .subform {
    position: relative;
  }

  .subcomment-input-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    background-color: var(--color-background);
    border: 1px solid var(--color-border);
    border-radius: 20px;
    padding: 8px 12px;
  }

  .comment-avatar-small {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
  }

  .comment-avatar-placeholder-small {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: var(--color-primary);
    color: var(--color-surface);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 14px;
    flex-shrink: 0;
  }

  .subcomment-input {
    flex: 1;
    border: none;
    outline: none;
    background-color: transparent;
    color: var(--color-text-tertiary);
    font-size: 14px;
    padding: 0;

    @media (min-width: 350px) and (max-width: 450px) {
      font-size: 11px;
    }
  }

  .subcomment-input::placeholder {
    color: var(--color-text-tertiary);
  }

  .profile-img {
    width: 35px;
    height: 35px;
    border-radius: 50px;
  }
  .comment-cart {
    width: 100%;
    height: auto;
    margin-bottom: 16px;
  }
  .comments {
    width: 100%;
    height: auto;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .show-replies-link {
    display: block;
    color: var(--color-text-secondary);
    cursor: pointer;
    font-size: 10px;
    font-weight: 500;
    margin-bottom: 8px;
    transition: opacity 0.2s;
  }

  .show-replies-link:hover {
    opacity: 0.8;
    text-decoration: underline;
  }

  .subcomments {
    margin-left: 45px;
    margin-top: 8px;
    padding-left: 10px;
    border-left: 2px solid var(--color-border);
  }

  .subcomment-cart {
    margin-bottom: 16px;
  }

  .subcomment-cart:last-child {
    margin-bottom: 0;
  }

  .send-btn {
    position: absolute;
    right: 7px;
    top: 4px;
    border: none;
    outline: none;
    background-color: transparent;
    color: var(--color-text-tertiary);
  }

  .subsend-btn {
    background-color: transparent;
    color: var(--color-primary);
    border: none;
    border-radius: 20px;
    padding: 6px 12px;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    transition: opacity 0.2s;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .subsend-btn:hover {
    opacity: 0.8;
  }

  .subsend-btn svg {
    color: var(--color-primary);
  }

  .story-description {
    padding: 5px;
    margin-bottom: 0px;
    padding-right: 20px;
    padding-top: 15px;
    margin-top: 15px;
    border-top: 1px solid var(--color-border);
    color: var(--color-text-tertiary);
    height: auto;
    text-align: justify;
    font-family: "Georgia",  serif;
    font-size: 20px;
    line-height: 1.8;
    min-height: 200px;
    word-wrap: break-word;
    white-space: normal;
  }
  .story-description p,
  .story-description span,
  .story-description strong,
  .story-description em,
  .story-description u,
  .story-description * {
    color: var(--color-text-tertiary) !important;
  }

  .story-description.sindhi-text,
  .story-description.sindhi-text p,
  .story-description.sindhi-text span,
  .story-description.sindhi-text strong,
  .story-description.sindhi-text em,
  .story-description.sindhi-text u {
    font-family: "SHREE-DEV7-0714", Arial, Helvetica, sans-serif;
    font-size: 22px;
  }

  .icon {
    margin-top: 10px;
    gap: 15px;
    display: flex;
    margin-left: 7px;
    @media (min-width: 350px) and (max-width: 700px) {
      margin-left: 25px;
    }
  }

  .heading {
    display: flex;
    color: var(--color-text);
    font-size: 2.4rem;
    font-weight: 800;
    margin-left: 1px;
    margin-bottom: 8px;
    line-height: 1.15;
    letter-spacing: -0.5px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-word;
    max-width: 100%;

    @media (max-width: 600px) {
      order: 2;
      font-size: 1.8rem;
    }
  }

  .heading-container {
    align-items: center;
    gap: 10px;
  }

  .name {
    color: var(--color-text-tertiary);
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: -0.4px;
    margin-top: 5px;
    text-decoration: none;
    @media (min-width: 350px) and (max-width: 450px) {
      font-size: 12px;
      margin-top: 5px;
    }

    @media (min-width: 701px) and (max-width: 800px) {
      font-size: 14px;
    }
  }
  .time {
    margin-top: -6px;
    font-size: 10px;
    color: var(--color-text-secondary);
    text-decoration: none;
  }
  .user-img {
    width: 50px;
    height: 50px;
    border-radius: 50px;
  }

  .user-details {
    display: flex;
    gap: 10px;
  }

  .story-container {
    width: 85%;
    max-width: 100%;
    height: auto;
    margin-top: 50px;
    background-color: var(--color-surface);
    border-radius: 16px;
    padding: 32px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    margin-bottom: 30px;
    box-sizing: border-box;

    @media (max-width: 1024px) {
      width: 90%;
    }

    @media (max-width: 768px) {
      width: 95%;
      padding: 16px;
      margin-top: 20px;
      border-radius: 12px;
    }
  }

  .sound-icon {
    margin-left: 5px;
  }
  .img {
    width: 260px;
    height: 170px;
    border-radius: 16px;
    object-fit: cover;

    @media (max-width: 900px) {
      width: 200px;
      height: 130px;
    }
  }

  .story-header {
    width: 100%;
    min-height: auto;
    gap: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    overflow: hidden;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 15px;
    }
  }

  .story-heading {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow: hidden;

    @media (max-width: 768px) {
      width: 100%;
      display: flex;
    }
  }

  .user-profile {
    margin-bottom: 15px;
    @media (max-width: 768px) {
      order: 1;
      margin-bottom: 0;
      width: 100%;
    }
  }

  .metadata-tags {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 10px;

    @media (max-width: 480px) {
      gap: 6px;
      margin-top: 8px;
    }
  }

  .metadata-tags-desktop {
    display: flex;
    @media (max-width: 768px) {
      display: none;
    }
  }

  .metadata-tags-mobile {
    display: none;
    @media (max-width: 768px) {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      margin-top: 10px;
      width: 100%;
      justify-content: flex-start;
    }
  }

  .owner-actions,
  .owner-actions-mobile {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .owner-actions {
    margin-left: auto;
  }

  .portfolio-btn {
    background-color: var(--color-background);
    color: var(--color-text-tertiary);
    border: 1px solid var(--color-border);
    border-radius: 8px;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 18px;
  }

  .badge-tag {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 5px 11px;
    border: 1px solid var(--color-border);
    border-radius: 8px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--color-primary);
    white-space: nowrap;
    background-color: #f9fafc;

    svg {
      flex-shrink: 0;
      color: var(--color-primary);
    }

    @media (max-width: 600px) {
      padding: 4px 9px;
      font-size: 10px;
    }
  }

  .badge-lang-container {
    position: relative;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  .lang-select-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    font-size: 11px;
  }

  .thumbnail {
    flex-shrink: 0;
  }

  .comment-section {
    width: 100%;
    padding-top: 16px;
    padding-bottom: 0;
    height: auto;
    margin-top: 16px;
    border-top: 1px solid var(--color-border);
  }

  .tts-controls-compact {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
    padding-top: 15px;
  }

  .progress-bar-container {
    width: 100%;
  }

  .sound-setting-compact {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .select-compact {
    padding: 4px 8px;
    border-radius: 6px;
    border: 1px solid var(--color-border);
    background-color: var(--color-background);
    color: var(--color-text-tertiary);
    font-size: 12px;
    outline: none;
    cursor: pointer;
    height: fit-content;
  }
  .form {
    position: relative;
  }

  .subform {
    position: relative;
    display: flex;
    justify-content: end;
  }

  .user-comment {
    display: none;
  }

  .delete-comment-btn {
    cursor: pointer;
    color: var(--color-text-tertiary);
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    transition: opacity 0.2s;
  }

  .delete-comment-btn:hover {
    opacity: 0.7;
  }
  .user-profile {
    display: flex;
    margin-top: 20px;
    gap: 30px;
  }

  .tts-controls {
    display: flex;
    gap: 10px;
    align-items: center;
    margin: 15px 0;
    background-color: #0c343a;
    padding: 15px;
    border-radius: 8px;
  }

  .tts-select {
    padding: 8px 12px;
    border-radius: 5px;
    border: 1px solid var(--color-border);
    background-color: var(--color-background);
    color: var(--color-text-tertiary);
    min-width: 180px;
    font-size: 14px;
    cursor: pointer;
    outline: none;
    transition: all 0.2s ease;

    &:hover {
      border-color: #52b2cf;
    }

    &:focus {
      border-color: #52b2cf;
      box-shadow: 0 0 0 2px rgba(82, 178, 207, 0.2);
    }

    option {
      background-color: var(--color-background);
      color: var(--color-text-tertiary);
      padding: 8px;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .tts-button {
    padding: 8px 20px;
    border-radius: 5px;
    border: none;
    background-color: var(--color-primary);
    color: var(--color-surface);
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 14px;
    min-width: 100px;
    text-align: center;

    &:hover:not(:disabled) {
      background-color: #52b2cf;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &.playing {
      background-color: #c81919;

      &:hover {
        background-color: #e01e1e;
      }
    }
  }

  .audio-player-card {
    display: flex;
    align-items: center;
    gap: 14px;
    background-color: #f9fafc;
    border: 1px solid var(--color-border);
    border-radius: 14px;
    padding: 14px 18px;
    margin-top: 20px;
    margin-bottom: 4px;

    @media (max-width: 600px) {
      padding: 12px 14px;
      gap: 10px;
    }
  }

  .audio-play-btn {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background-color: var(--color-primary);
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-surface);
    flex-shrink: 0;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.85;
    }

    svg {
      color: var(--color-surface);
    }
  }

  .audio-player-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 7px;
    min-width: 0;
  }

  .audio-player-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .audio-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.12em;
    color: var(--color-primary);
    text-transform: uppercase;
  }

  .audio-progress-bar {
    width: 100%;
    height: 4px;
    background-color: var(--color-border);
    border-radius: 4px;
    overflow: hidden;
  }

  .audio-progress-fill {
    height: 100%;
    background-color: var(--color-primary);
    border-radius: 4px;
    transition: width 0.3s linear;
  }

  .audio-time {
    font-size: 12px;
    color: var(--color-text-secondary);
    white-space: nowrap;
    flex-shrink: 0;
    font-variant-numeric: tabular-nums;
  }

  .view-all-btn {
    display: block;
    width: 100%;
    padding: 12px;
    margin-top: 16px;
    background-color: #f1f3f5;
    border: none;
    border-radius: 10px;
    color: var(--color-text-secondary);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.8px;
    cursor: pointer;
    text-align: center;
    text-transform: uppercase;
    transition: background-color 0.2s, color 0.2s;

    &:hover {
      background-color: #e4e6e9;
      color: var(--color-text);
    }
  }

`;
